import $http from "../axios";

const state = {
  isPromotionsOptInActive: false
};

const getters = {
  isPromotionsOptInActive(state) {
    return state.isPromotionsOptInActive;
  }
};

const actions = {
  changeStoreStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`change-store-status`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_STORE_STATUS", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  createCashback({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`create-cashback`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("CREATE_CASHBACK", {
              storeId: data.storeId,
              cashback: res.data.payload.cashback
            });
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setCashback({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-cashback`, data)
        .then(res => {
          commit("SET_CASHBACK_STATUS", {
            ...data,
            success: res.data.result === "ok"
          });
          resolve(res);
        })
        .catch(e => {
          commit("SET_CASHBACK_STATUS", {
            ...data,
            success: false
          });
          reject(e);
        });
    });
  },

  deleteCashback({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`delete-cashback`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("DELETE_CASHBACK", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  createCoupon({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`create-coupon`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("CREATE_COUPON", {
              storeId: data.storeId,
              coupon: res.data.payload.coupon
            });
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  deleteCoupon({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`delete-coupon`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("DELETE_COUPON", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateCoupon({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-coupon", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_COUPON", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setNotification({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-notification`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_NOTIFICATION", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  participateInPromotion({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`participate-promotion`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("PARTICIPATE_PROMOTION", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updatePromotionalImageLink({ commit }, data) {
    commit("UPDATE_PROMOTIONAL_IMAGE_LINK", data);
  },

  togglePromotionalImageStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`toggle-promotional-image-status`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_PROMOTIONAL_IMAGE_STATUS", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updatePromotionalImageDate({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`update-promotional-image-date`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_PROMOTIONAL_IMAGE_DATE", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  removePromotionalImage({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`remove-promotional-image`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_PROMOTIONAL_IMAGE_LINK", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setAccessWithoutPaymentMethods({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-access-without-payment-methods`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_ACCESS_WITHOUT_PAYMENT_METHODS", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setShowOpenDoorButtonInCart({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-show-open-door-button-in-cart`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_OPEN_DOOR_BUTTON_IN_CART", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setShowCatalog({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-show-catalog`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_SHOW_CATALOG", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setShowCatalogOutsideStore({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-show-catalog-outside-store`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_SHOW_CATALOG_OUTSIDE_STORE", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setShowStockQty({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-show-stock-qty`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_SHOW_STOCK_QTY", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setProductAdditionViaCatalog({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-product-addition-via-catalog`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_PRODUCT_ADDITION_VIA_CATALOG", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setSearchNotFoundProductsInMyOtherStores({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-search-not-found-products-in-my-other-stores`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_SEARCH_NOT_FOUND_PRODUCTS_IN_MY_OTHER_STORES", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setAllowListAccessRestriction({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-allow-list-access-restriction`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_ALLOW_LIST_ACCESS_RESTRICTION", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateAllowList(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`update-allow-list`, data)
        .then(res => {
          // if (res.data.result === "ok") {
          //   commit("SET_ALLOW_LIST_ACCESS_RESTRICTION", data);
          // }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setEcommercePayment({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-ecommerce-payment`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_ECOMMERCE_PAYMENT", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setEcommerceCartValueLimitActive({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-ecommerce-cart-value-limit-active`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_ECOMMERCE_CART_VALUE_LIMIT_ACTIVE", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setEcommerceCartValueLimit({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-ecommerce-cart-value-limit`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_ECOMMERCE_CART_VALUE_LIMIT", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setDefaultVAT({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`set-default-vat`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_DEFAULT_VAT", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  bulkAddCoupons(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("bulk-add-coupons", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_IS_PROMOTIONS_OPT_IN_ACTIVE(state, data) {
    state.isPromotionsOptInActive = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
